// P:\0PJ\synforge\frontend\lib\api\branch.ts v2 2026.09.08 - handoff()에
//   join_as_panelist 파라미터 추가(사용자 패널 참여 여부를 백엔드로 전달)
import { api } from "./core"

export const branchAPI = {
  decide: (
    agenda: string,
    files?: { base64: string; mime_type: string; name: string }[],
    conversationId?: number,
    history?: { role: string; content: string }[],
    fieldOverride?: string,
    contextAnswers?: Record<string, string>,
  ) => {
    const locale =
      typeof document !== "undefined"
        ? document.cookie.split("; ").find((r) => r.startsWith("locale="))?.split("=")[1]
        : undefined
    return api.post("/branch/", {
      agenda,
      files: files || [],
      conversation_id: conversationId ?? null,
      history: history || [],
      field_override: fieldOverride || "",
      context_answers: contextAnswers || {},
      locale: locale || "en",
    })
  },

  handoff: (agenda: string, conversationId?: number, joinAsPanelist?: boolean) =>
    api.post("/branch/handoff/", {
      agenda,
      conversation_id: conversationId ?? null,
      join_as_panelist: joinAsPanelist ?? false,
    }),

  handoffDetail: (handoffId: string) =>
    api.get(`/branch/handoff/${handoffId}/`),

  handoffCancel: (handoffId: string) =>
    api.post(`/branch/handoff/${handoffId}/cancel/`),

  handoffContextAnswer: (
    handoffId: string,
    answers: Record<string, string>,
    files?: Record<string, { base64: string; mime_type: string; name: string }>,
  ) =>
    api.post(`/branch/handoff/${handoffId}/context-answer/`, { answers, files: files || {} }),

  list: () => api.get("/branch/handoffs/"),

  conversations: () => api.get("/branch/conversations/"),

  conversationDetail: (conversationId: number) =>
    api.get(`/branch/conversations/${conversationId}/`),

  handoffDelete:  (handoffId: string) => api.post(`/branch/handoff/${handoffId}/delete/`),
  handoffRestore: (handoffId: string) => api.post(`/branch/handoff/${handoffId}/restore/`),

  trash: () => api.get("/branch/trash/"),
}

export const branchProjectAPI = {
  decide: (
    projectId: string,
    agenda: string,
    files?: { base64: string; mime_type: string; name: string }[],
  ) => {
    const locale =
      typeof document !== "undefined"
        ? document.cookie.split("; ").find((r) => r.startsWith("locale="))?.split("=")[1]
        : undefined
    return api.post("/branch-project/", {
      project_id: projectId,
      agenda,
      files: files || [],
      locale: locale || "en",
    })
  },

  handoff: (agenda: string, conversationId: number) =>
    api.post("/branch-project/handoff/", {
      agenda,
      conversation_id: conversationId,
    }),

  handoffDetail:        branchAPI.handoffDetail,
  handoffCancel:        branchAPI.handoffCancel,
  handoffContextAnswer: branchAPI.handoffContextAnswer,
}

export interface ReviewTurnItem {
  order: number
  kind: "reason" | "question" | "answer" | "compose" | "note"
  content: string
  options: string[]
  is_user: boolean
}

export interface ReviewStepPayload {
  review_id: string
  status: string
  agenda: string
  revised_agenda: string
  meeting_type: string
  done: boolean
  question: string
  options: string[]
  turns: ReviewTurnItem[]
  total_tokens: number
  total_cost_usd: number
}

export const reviewAPI = {
  detail: (reviewId: string) =>
    api.get<ReviewStepPayload>(`/branch/review/${reviewId}/`),

  answer: (reviewId: string, answer: string) =>
    api.post<ReviewStepPayload>(`/branch/review/${reviewId}/answer/`, { answer }),

  revise: (reviewId: string, note: string) =>
    api.post<ReviewStepPayload>(`/branch/review/${reviewId}/revise/`, { note }),

  confirm: (reviewId: string, agenda: string) =>
    api.post<ReviewStepPayload>(`/branch/review/${reviewId}/confirm/`, { agenda }),

  cancel: (reviewId: string) =>
    api.post<ReviewStepPayload>(`/branch/review/${reviewId}/cancel/`, {}),

  remove:  (reviewId: string) => api.post(`/branch/review/${reviewId}/delete/`),
  restore: (reviewId: string) => api.post(`/branch/review/${reviewId}/restore/`),
}